import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';
import { CampaignSelector } from './index';

export class CampaignSelectorView extends Backbone.View {
  initialize({
    i18n,
    fetch,
    selectedItem = null,
    stringKeys,
    checkSelected,
    pageSize,
    campaign,
    ariaLabel = '',
    searchBoxAriaLabel = '',
    isToggled,
    isMultiMode,
    onSelectDone,
  }) {
    this.i18n = i18n;
    this.selectedItem = selectedItem;
    this.fetch = fetch;
    this.stringKeys = stringKeys;
    this.checkSelected = checkSelected;
    this.pageSize = pageSize;
    this.campaign = campaign;
    this.ariaLabel = ariaLabel;
    this.searchBoxAriaLabel = searchBoxAriaLabel;
    this.isToggled = isToggled;
    this.isMultiMode = isMultiMode;
    this.onSelectDone = onSelectDone;

    this.onSelect = this.onSelect.bind(this);
  }

  onSelect(selectedItem) {
    this.selectedItem = selectedItem;
    this.trigger('selected-campaign', selectedItem);
    this.render();
  }

  render() {
    ReactDOM.render(
      (
        <CampaignSelector
          i18n={this.i18n}
          fetch={this.fetch}
          onSelect={this.onSelect}
          onSelectDone={this.onSelectDone}
          selectedItem={this.selectedItem}
          stringKeys={this.stringKeys}
          checkSelected={this.checkSelected}
          pageSize={this.pageSize}
          campaign={this.campaign}
          ariaLabel={this.ariaLabel}
          searchBoxAriaLabel={this.searchBoxAriaLabel}
          isToggled={this.isToggled}
          isMultiMode={this.isMultiMode}
        />
      ), this.el
    );
    return this;
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
